import { createContext, useContext } from 'react';
import ContentService from '../../services/content';
import { ContentAction } from './actions';

export interface IContent {
  siteMap?: any;
  header?: any;
  footer?: any;
  notification?: any;
  page?: any;
  cart?: any;
  printRx?: any;
}
export interface IContentState {
  content?: IContent;
  service?: ContentService;
  dispatch: React.Dispatch<ContentAction>;
  error: boolean;
}

export const INITIAL_STATE = {
  error: false,

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  dispatch: (action: ContentAction) => {
    return;
  },
};
export const ContentContext = createContext<IContentState>(INITIAL_STATE);
export const useContent = () => {
  const ctx = useContext(ContentContext);
  return ctx;
};
